module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-15-18.040Z.4258730f.png";